var map = {
	"./img/SF EXPRESS.png": 1081,
	"./img/about/about_us_bg.png": 1145,
	"./img/about/company_address.png": 1146,
	"./img/about/company_introduction.png": 1147,
	"./img/about/contact_bg.png": 1148,
	"./img/about/contact_bg_m.png": 1149,
	"./img/about/corporate_culture.png": 1150,
	"./img/about/corporate_history.png": 1151,
	"./img/about/intro/about_001.png": 1152,
	"./img/about/intro/about_002.png": 1153,
	"./img/about/intro/about_003.png": 1154,
	"./img/about/intro/about_004.png": 1155,
	"./img/about/intro/banner.png": 1156,
	"./img/about/intro/banner_bg_001.png": 1157,
	"./img/about/intro/banner_bg_002.png": 1158,
	"./img/about/intro/course/course_001.png": 1159,
	"./img/about/intro/course/course_0010.png": 1160,
	"./img/about/intro/course/course_0011.png": 1161,
	"./img/about/intro/course/course_0012.png": 1162,
	"./img/about/intro/course/course_0013.png": 1163,
	"./img/about/intro/course/course_0014.png": 1164,
	"./img/about/intro/course/course_002.png": 1165,
	"./img/about/intro/course/course_003.png": 1166,
	"./img/about/intro/course/course_004.png": 1167,
	"./img/about/intro/course/course_005.png": 1168,
	"./img/about/intro/course/course_006.png": 1169,
	"./img/about/intro/course/course_007.png": 1170,
	"./img/about/intro/course/course_008.png": 1171,
	"./img/about/intro/course/course_009.png": 1172,
	"./img/about/intro/course/course_line.png": 1173,
	"./img/about/intro/culture/en_US.jpg": 1537,
	"./img/about/intro/culture/th_TH.jpg": 1538,
	"./img/about/intro/culture/vi_VN.jpg": 1539,
	"./img/about/intro/culture/zh_CN.jpg": 1540,
	"./img/about/intro/culture2/en_US.jpg": 1082,
	"./img/about/intro/culture2/ja_JP.jpg": 1083,
	"./img/about/intro/culture2/ko_KR.jpg": 1084,
	"./img/about/intro/culture2/mobile/en_US.jpg": 997,
	"./img/about/intro/culture2/mobile/ja_JP.jpg": 998,
	"./img/about/intro/culture2/mobile/zh_CN.jpg": 999,
	"./img/about/intro/culture2/th_TH.jpg": 1085,
	"./img/about/intro/culture2/vi_VN.jpg": 1086,
	"./img/about/intro/culture2/zh_CN.jpg": 1087,
	"./img/about/intro/desire/desire_001.png": 1174,
	"./img/about/intro/desire/desire_002.png": 1175,
	"./img/about/intro/desire/desire_003.png": 1176,
	"./img/about/intro/desire/desire_004.png": 1177,
	"./img/about/intro/desire/desire_005.png": 1178,
	"./img/about/intro/honor/honor_001.png": 1088,
	"./img/about/intro/honor/honor_002.png": 1089,
	"./img/about/intro/honor/honor_003.png": 1090,
	"./img/about/intro/honor/honor_004.png": 1091,
	"./img/about/intro/honor/honor_005.png": 1092,
	"./img/about/intro/honor/honor_sg_001.png": 1093,
	"./img/about/intro/honor/honor_sg_002.png": 1094,
	"./img/about/intro/icon_001.png": 934,
	"./img/about/intro/icon_002.png": 935,
	"./img/about/intro/icon_003.png": 936,
	"./img/about/intro/icon_004.png": 937,
	"./img/about/intro/icon_005.png": 949,
	"./img/about/intro/icon_006.png": 950,
	"./img/about/intro/koreasf/cargo.png": 1179,
	"./img/about/intro/koreasf/charter-1.png": 1180,
	"./img/about/intro/koreasf/charter-2.png": 1181,
	"./img/about/intro/koreasf/charter-3.png": 1182,
	"./img/about/intro/koreasf/coverage.png": 1183,
	"./img/about/intro/koreasf/dazhixianjiantou.png": 1184,
	"./img/about/intro/koreasf/earth-card.png": 1185,
	"./img/about/intro/koreasf/ezhou-airport.png": 1186,
	"./img/about/intro/koreasf/fleet-plane.png": 1187,
	"./img/about/intro/koreasf/korea-map-watermark.png": 1188,
	"./img/about/intro/koreasf/news-1.png": 1189,
	"./img/about/intro/koreasf/news-2.png": 1190,
	"./img/about/intro/koreasf/news-3.png": 1191,
	"./img/about/intro/koreasf/revenue.png": 1192,
	"./img/about/intro/koreasf/service-express-figure.png": 1193,
	"./img/about/intro/koreasf/service-express.png": 1194,
	"./img/about/intro/koreasf/service-finance.png": 1195,
	"./img/about/intro/koreasf/service-kandash.png": 1196,
	"./img/about/intro/koreasf/service-points.png": 1197,
	"./img/about/intro/koreasf/service-smart.png": 1198,
	"./img/about/intro/koreasf/service-supply.png": 1199,
	"./img/about/intro/koreasf/sf-korea-logo.png": 1095,
	"./img/about/intro/koreasf/sf-korea-photo.png": 1200,
	"./img/about/intro/koreasf/staff-photo-2.png": 1201,
	"./img/about/intro/koreasf/staff-photo-3.png": 1202,
	"./img/about/intro/koreasf/staff-photo-main.png": 1203,
	"./img/about/intro/koreasf/xiejiantou.png": 1204,
	"./img/about/intro/koreasf/zhixianjiantou-red.png": 1205,
	"./img/about/intro/koreasf/zhixianjiantou.png": 1206,
	"./img/about/intro/mb/banner.png": 1207,
	"./img/about/intro/mb/product_bg.png": 1096,
	"./img/about/jp-about-us-bg.png": 1208,
	"./img/about/location.png": 1209,
	"./img/about/pc_board.jpg": 1022,
	"./img/about/pc_careers.png": 968,
	"./img/about/pc_contact.jpg": 944,
	"./img/about/pc_intr.jpg": 1541,
	"./img/about/pc_text_bg.png": 905,
	"./img/about/president_message.png": 1542,
	"./img/about/president_message_en.jpg": 1210,
	"./img/about/president_message_ja.jpg": 1211,
	"./img/about/president_message_sc.jpg": 1212,
	"./img/about/service_point.png": 1543,
	"./img/about/talent_recruitment.png": 1213,
	"./img/alert-circle-solid.png": 1544,
	"./img/allCustomsClearanceServices/allCustomsClearanceServicesMainTop.png": 1214,
	"./img/allCustomsClearanceServices/pieceOneImg1.png": 1545,
	"./img/allCustomsClearanceServices/pieceOneImg2.png": 1546,
	"./img/allCustomsClearanceServices/pieceOneImg3.png": 1547,
	"./img/allCustomsClearanceServices/pieceOneImg4.png": 1215,
	"./img/allCustomsClearanceServices/pieceOneImg5.png": 1216,
	"./img/allCustomsClearanceServices/pieceOneImg6.png": 1217,
	"./img/allCustomsClearanceServices/rightBottom1.svg": 1218,
	"./img/allCustomsClearanceServices/rightBottom2.svg": 1219,
	"./img/allCustomsClearanceServices/rightBottom3.svg": 1220,
	"./img/allCustomsClearanceServices/rightBottom4.svg": 1221,
	"./img/allCustomsClearanceServices/rightBottom5.svg": 1222,
	"./img/allCustomsClearanceServices/rightBottom6.svg": 1223,
	"./img/allCustomsClearanceServices/rightBottom7.svg": 1224,
	"./img/allCustomsClearanceServices/selfServiceImg1.svg": 1225,
	"./img/allCustomsClearanceServices/selfServiceImg2.svg": 1226,
	"./img/allCustomsClearanceServices/selfServiceImg3.svg": 1227,
	"./img/arrow_right.png": 1548,
	"./img/arrow_right_more.png": 1549,
	"./img/arrow_right_two.png": 896,
	"./img/arrows/arrow-right-gray.png": 1228,
	"./img/arrows/arrow-right-white.png": 1097,
	"./img/arrows/arrow.png": 1229,
	"./img/arrows/up.png": 1098,
	"./img/businessCooperation/businessCooperation-pc.png": 969,
	"./img/chevron-up.png": 1550,
	"./img/class-banner.jpg": 1551,
	"./img/class-banner1.png": 1099,
	"./img/class-banner_bg.png": 1100,
	"./img/class-bluk-banner-jp.png": 1230,
	"./img/class-delivery-banner-jp.png": 1000,
	"./img/class-disct-banner-jp.png": 1231,
	"./img/class-fast-banner-jp.png": 1232,
	"./img/comprehensive/title.png": 1233,
	"./img/concat_computer.png": 1552,
	"./img/concat_email.png": 1553,
	"./img/concat_phone.png": 1554,
	"./img/concat_qq.png": 1555,
	"./img/consign/guide_m_vi.png": 1234,
	"./img/consign/guide_vi.png": 1235,
	"./img/consign/img_1.png": 951,
	"./img/consign/qrcode_2.png": 1023,
	"./img/consign/qrcode_3.jpg": 1101,
	"./img/consign/qrcode_3.png": 1001,
	"./img/consign/sf_go_vn.jpeg": 1102,
	"./img/consign/wrapper_bg.png": 1236,
	"./img/consign/wrapper_m_bg.png": 1237,
	"./img/contact-portrait.png": 970,
	"./img/customerService.png": 1556,
	"./img/dashed.png": 1238,
	"./img/edit.png": 1103,
	"./img/error_404bg-m.jpg": 479,
	"./img/error_404bg.jpg": 480,
	"./img/europe.svg": 1239,
	"./img/failedQrcode.png": 1002,
	"./img/footer/gb_xhs_2wm.svg": 1557,
	"./img/footer/ic_close.svg": 1003,
	"./img/footer/ic_qrcode_douyin.png": 1558,
	"./img/footer/ic_qrcode_facebook.png": 1559,
	"./img/footer/ic_qrcode_ins.png": 1560,
	"./img/footer/ic_qrcode_line.png": 1561,
	"./img/footer/ic_qrcode_lingying.png": 1562,
	"./img/footer/ic_qrcode_linkin.png": 1563,
	"./img/footer/ic_qrcode_tiktok.png": 1564,
	"./img/footer/ic_qrcode_tw.png": 1565,
	"./img/footer/ic_qrcode_wechat.jpg": 375,
	"./img/footer/ic_qrcode_weibo.png": 1566,
	"./img/footer/ic_qrcode_youbute.png": 1567,
	"./img/footer/jialiwuliu.png": 1240,
	"./img/footer/jp_xhs_2wm.jpg": 1568,
	"./img/footer/jp_xhs_qrcode.jpg": 1569,
	"./img/footer/line.svg": 1570,
	"./img/footer/my_qrcode_facebook.png": 1571,
	"./img/footer/my_qrcode_ins.png": 1572,
	"./img/footer/my_qrcode_ins_us.png": 1573,
	"./img/footer/my_qrcode_lingying.png": 1574,
	"./img/footer/my_qrcode_lingying_us.png": 1575,
	"./img/footer/ph_qrcode_viber.png": 1576,
	"./img/footer/ph_qrcode_wechat.png": 1577,
	"./img/footer/ph_qrcode_whatsapp.png": 1578,
	"./img/footer/ph_qrcode_xiaohongshu.png": 1579,
	"./img/footer/sg_qrcode_whatsapp.png": 1580,
	"./img/footer/us_xhs.png": 1581,
	"./img/footer/vn_qrcode_fb.png": 1582,
	"./img/footer/vn_qrcode_tk.png": 1583,
	"./img/footer/vn_qrcode_wechat.jpg": 540,
	"./img/footer/vn_qrcode_zalo.png": 1584,
	"./img/format/doc.png": 1024,
	"./img/format/jpg.png": 1025,
	"./img/format/pdf.png": 1026,
	"./img/format/png.png": 1027,
	"./img/format/xls.png": 1028,
	"./img/header-countryicon.png": 1241,
	"./img/header-phoneicon.png": 1585,
	"./img/home/dianshang.jpg": 1586,
	"./img/home/extension_news_bg.jpg": 1587,
	"./img/home/homeRightImg.png": 1588,
	"./img/home/kr-card-bottom-1.png": 1242,
	"./img/home/kr-card-bottom-2.png": 1243,
	"./img/home/kr-card-bottom-3.png": 1244,
	"./img/home/kr-card-bottom-4.png": 1245,
	"./img/home/kr-card-bottom-5.png": 1246,
	"./img/home/kr-card-top-icon-1.png": 1247,
	"./img/home/kr-card-top-icon-2.png": 1248,
	"./img/home/kr-card-top-icon-3.png": 1249,
	"./img/home/kr-card-top-icon-4.png": 1250,
	"./img/home/kr-card-top-icon-5.png": 1251,
	"./img/home/kr-card-top-icon-white-1.png": 1252,
	"./img/home/kr-card-top-icon-white-2.png": 1253,
	"./img/home/kr-card-top-icon-white-3.png": 1254,
	"./img/home/kr-card-top-icon-white-4.png": 1255,
	"./img/home/kr-card-top-icon-white-5.png": 1256,
	"./img/home/kr-product-footer-banner-bg.png": 1104,
	"./img/home/kr-product-footer-icon.png": 1105,
	"./img/home/kr-product-footer.png": 1257,
	"./img/home/kr-product-title-img-1.png": 1258,
	"./img/home/kr-product-title-img-2.png": 1259,
	"./img/home/kr-product-title-img-3.png": 1260,
	"./img/home/kr-product-title-img-4.png": 1261,
	"./img/home/kr-product-title-img-5.png": 1262,
	"./img/home/kr-red-card-right-bottom-1.png": 1263,
	"./img/home/kr-red-card-right-bottom-2.png": 1264,
	"./img/home/kr-red-card-right-bottom-3.png": 1265,
	"./img/home/kr-red-card-right-bottom-4.png": 1266,
	"./img/home/kr-red-card-right-bottom-5.png": 1267,
	"./img/home/kuaidi.jpg": 1589,
	"./img/home/newSolution_bg1.jpg": 1590,
	"./img/home/product-card-kr.png": 1268,
	"./img/home/product-kr-cardBg-red.png": 1591,
	"./img/home/product_01.png": 1592,
	"./img/home/product_02.png": 1593,
	"./img/home/product_bg_01.png": 1269,
	"./img/home/product_bg_01_en_01.png": 1594,
	"./img/home/product_bg_01_sc_01.png": 1595,
	"./img/home/product_bg_02.png": 1270,
	"./img/home/product_bg_kr.png": 1271,
	"./img/home/product_bg_new_01.svg": 1596,
	"./img/home/product_bg_new_02.svg": 1597,
	"./img/home/product_bg_new_03.png": 1598,
	"./img/home/product_bg_new_04.png": 1599,
	"./img/home/product_mb_01.png": 1600,
	"./img/home/product_mb_02.png": 1601,
	"./img/home/product_mb_cn_kr.png": 1602,
	"./img/home/product_mb_cn_kr.svg": 1603,
	"./img/home/product_mb_new_01.svg": 1272,
	"./img/home/product_mb_new_02.svg": 1273,
	"./img/home/product_mb_new_03.png": 1274,
	"./img/home/product_mb_new_04.png": 1604,
	"./img/home/product_mb_us_eu_au_fr_de.png": 1605,
	"./img/home/product_mb_us_eu_au_fr_de.svg": 1606,
	"./img/home/product_mb_vn_th_my_sg_ph.png": 1607,
	"./img/home/product_mb_vn_th_my_sg_ph.svg": 1608,
	"./img/home/service_notice.png": 1609,
	"./img/home/solution_bg1.jpg": 1610,
	"./img/home/solution_bg2.png": 1611,
	"./img/home_search_02.png": 1612,
	"./img/icons/JapanIcon.png": 541,
	"./img/icons/active_point.svg": 952,
	"./img/icons/address.svg": 1029,
	"./img/icons/appTableNoData.png": 1613,
	"./img/icons/arrow/double-arrows.svg": 1004,
	"./img/icons/arrow_bg.svg": 933,
	"./img/icons/arrow_down.svg": 1030,
	"./img/icons/back2Top.png": 1031,
	"./img/icons/chadan.svg": 1032,
	"./img/icons/check.png": 1614,
	"./img/icons/close.png": 1275,
	"./img/icons/complete.png": 1033,
	"./img/icons/curve-black.svg": 1034,
	"./img/icons/curve-grey.svg": 1035,
	"./img/icons/curve/curve-active.svg": 1036,
	"./img/icons/curve/curve-inactive.svg": 1037,
	"./img/icons/customsDeclaration.svg": 1038,
	"./img/icons/customsDeclarationActive.svg": 1039,
	"./img/icons/douyin.svg": 1040,
	"./img/icons/drop_point.svg": 953,
	"./img/icons/empty-result.svg": 938,
	"./img/icons/error.svg": 1041,
	"./img/icons/facebook.svg": 1042,
	"./img/icons/gb_xhs.svg": 1043,
	"./img/icons/incomplete.png": 1044,
	"./img/icons/ins.svg": 1045,
	"./img/icons/jijian.svg": 1046,
	"./img/icons/jp_xhs.png": 1615,
	"./img/icons/jp_xhs.svg": 1047,
	"./img/icons/kakao.svg": 1048,
	"./img/icons/kefu.svg": 1049,
	"./img/icons/kr-blog.svg": 1050,
	"./img/icons/kuaisuxunjia.svg": 1051,
	"./img/icons/landing/enterprice.svg": 1005,
	"./img/icons/landing/rectangle.svg": 1006,
	"./img/icons/line.png": 1106,
	"./img/icons/lingyin.svg": 1052,
	"./img/icons/local_point.png": 1053,
	"./img/icons/logo.svg": 1054,
	"./img/icons/mashangjijian.svg": 1055,
	"./img/icons/overturn.svg": 971,
	"./img/icons/person.svg": 1007,
	"./img/icons/pick_point.svg": 954,
	"./img/icons/qq_detail.svg": 1008,
	"./img/icons/quarter-checked.png": 1009,
	"./img/icons/search_point.svg": 955,
	"./img/icons/shangwuhezuo.svg": 1056,
	"./img/icons/sousuo.svg": 1057,
	"./img/icons/submitHistoryIcon.svg": 1010,
	"./img/icons/submitHistoryIconActive.svg": 1011,
	"./img/icons/success-icon.svg": 972,
	"./img/icons/success.svg": 1058,
	"./img/icons/support/allow.svg": 956,
	"./img/icons/support/arrow-to.svg": 942,
	"./img/icons/support/iconPath.svg": 946,
	"./img/icons/support/picture.svg": 957,
	"./img/icons/support/prohibit.svg": 958,
	"./img/icons/support/restrict.svg": 959,
	"./img/icons/support/shipping-flow.svg": 960,
	"./img/icons/switch.svg": 939,
	"./img/icons/time.svg": 1059,
	"./img/icons/tongzhi1.svg": 1060,
	"./img/icons/tongzhi2.svg": 1061,
	"./img/icons/totalValue5.svg": 1012,
	"./img/icons/tw.png": 1616,
	"./img/icons/tw.svg": 1062,
	"./img/icons/viber.png": 1617,
	"./img/icons/vn_qrcode_wechat.jpg": 1618,
	"./img/icons/warning-icon.svg": 973,
	"./img/icons/warning.svg": 1063,
	"./img/icons/wb_detail.svg": 1013,
	"./img/icons/weibo.svg": 1064,
	"./img/icons/whatsapp.png": 1619,
	"./img/icons/wx.svg": 1065,
	"./img/icons/wx_detail.svg": 1014,
	"./img/icons/xiaohongshu.png": 1620,
	"./img/icons/youbube.svg": 1066,
	"./img/icons/zalo.svg": 1067,
	"./img/img-error.png": 1621,
	"./img/intl-app-logo.png": 1276,
	"./img/invoice/invoice-template-au.png": 1622,
	"./img/invoice/invoice-template-nz.png": 1623,
	"./img/landing/active_product1.png": 1277,
	"./img/landing/active_product2.png": 1278,
	"./img/landing/active_product3.png": 1279,
	"./img/landing/active_product4.png": 1280,
	"./img/landing/apps/express-consign-miniapp.png": 1281,
	"./img/landing/apps/express-consign-sfapp.png": 1282,
	"./img/landing/apps/home-miniapp.png": 1283,
	"./img/landing/apps/main-consign-miniapp.png": 1284,
	"./img/landing/apps/main-consign-sfapp.png": 1285,
	"./img/landing/banner_ad.png": 974,
	"./img/landing/bend_arrow.png": 1107,
	"./img/landing/contact_us.png": 1286,
	"./img/landing/earth.png": 1287,
	"./img/landing/earth1.jpg": 1288,
	"./img/landing/footer_bg.png": 542,
	"./img/landing/icons/amazon.svg": 1289,
	"./img/landing/icons/authentication.svg": 1290,
	"./img/landing/icons/cainiao.svg": 1291,
	"./img/landing/icons/car.svg": 1292,
	"./img/landing/icons/compensation.svg": 1293,
	"./img/landing/icons/icon_1.png": 1294,
	"./img/landing/icons/icon_2.png": 1108,
	"./img/landing/icons/icon_3.png": 1109,
	"./img/landing/icons/icon_4.png": 1110,
	"./img/landing/icons/icon_5.svg": 1295,
	"./img/landing/icons/icon_6.svg": 1296,
	"./img/landing/icons/internet.svg": 1297,
	"./img/landing/icons/joom.svg": 1298,
	"./img/landing/icons/lazada.svg": 1299,
	"./img/landing/icons/pinduoduo.svg": 1300,
	"./img/landing/icons/service.svg": 1301,
	"./img/landing/icons/service_1.png": 1302,
	"./img/landing/icons/service_2.png": 1303,
	"./img/landing/icons/service_3.png": 1304,
	"./img/landing/icons/service_4.png": 1305,
	"./img/landing/icons/shopify.svg": 1306,
	"./img/landing/icons/track.svg": 1307,
	"./img/landing/icons/wish.svg": 1308,
	"./img/landing/line.png": 1309,
	"./img/landing/people.png": 1310,
	"./img/landing/platform.jpg": 1311,
	"./img/landing/product1.png": 1312,
	"./img/landing/product2.png": 1313,
	"./img/landing/product3.png": 1314,
	"./img/landing/product4.png": 1315,
	"./img/landing/route_country.png": 1316,
	"./img/landing/service_bg.png": 1317,
	"./img/loading.gif": 1624,
	"./img/loading.png": 1318,
	"./img/loading/snow.png": 1625,
	"./img/logistics/banner.jpg": 1111,
	"./img/logistics/bg_circle.png": 1626,
	"./img/logistics/cross-e-commerce.png": 1319,
	"./img/logistics/delivery.jpg": 975,
	"./img/logistics/discts.jpg": 976,
	"./img/logistics/fast.jpg": 977,
	"./img/logistics/ic_reddot.png": 1627,
	"./img/logistics/icon1.jpg": 1628,
	"./img/logistics/icon2.png": 1629,
	"./img/logistics/icon3.png": 1630,
	"./img/logistics/icon4.png": 1631,
	"./img/logistics/icon5.png": 1632,
	"./img/logistics/icon6.png": 1633,
	"./img/logistics/icon7.png": 1634,
	"./img/logistics/icon8.jpg": 1635,
	"./img/logistics/parcel.jpg": 1320,
	"./img/logistics/pic1.png": 1636,
	"./img/logistics/pic12.png": 1637,
	"./img/logistics/pic3.png": 1638,
	"./img/logistics/pic4_bg.png": 1639,
	"./img/logistics/pic4_bg_hover.png": 1640,
	"./img/logistics/pic5.png": 1641,
	"./img/logistics/pic5_bg.png": 1642,
	"./img/logistics/pic5_bg_hover.png": 1643,
	"./img/logistics/pic6.png": 1644,
	"./img/logistics/pic6_bg.png": 1645,
	"./img/logistics/product_ecomence_error.png": 1015,
	"./img/logistics/product_express_error.png": 1112,
	"./img/logistics/sfbuy.jpg": 1321,
	"./img/logistics/warehouse.jpg": 978,
	"./img/logo-black-express.png": 1646,
	"./img/logo-black.png": 1647,
	"./img/logo-chinese-express.png": 1648,
	"./img/logo-cn-white.png": 1649,
	"./img/logo-intl-express.png": 1113,
	"./img/logo-intl-expresstc.jpg": 1650,
	"./img/logo-intl-white.png": 1651,
	"./img/logo-intl.png": 1652,
	"./img/logo.png": 1653,
	"./img/logout-red.png": 543,
	"./img/logout.png": 544,
	"./img/navs/businessCooperation-on.png": 1114,
	"./img/navs/businessCooperation.png": 1115,
	"./img/navs/customerService-on.png": 1116,
	"./img/navs/customerService.png": 1117,
	"./img/navs/jpBusinessCooperation.png": 1322,
	"./img/navs/jpCustomerService.png": 1323,
	"./img/navs/jpSuggestion.png": 1324,
	"./img/navs/popover-bg.png": 1325,
	"./img/navs/suggestion-on.png": 1118,
	"./img/navs/suggestion.png": 1119,
	"./img/navs/wechat-on.png": 1120,
	"./img/navs/wechat.png": 1121,
	"./img/newJp/arrow-down-s-line.png": 1326,
	"./img/newJp/arrowRight.png": 961,
	"./img/newJp/arrowRightRed.png": 1654,
	"./img/newJp/backgroundImg.png": 1655,
	"./img/newJp/backgroundImg2.png": 1656,
	"./img/newJp/campus_recruitment.png": 1657,
	"./img/newJp/close-fat.png": 545,
	"./img/newJp/contact_mobile_noJp.png": 1122,
	"./img/newJp/contact_mobile_whatsApp_jp.png": 1123,
	"./img/newJp/contentImg1.png": 1327,
	"./img/newJp/contentImg2.png": 1328,
	"./img/newJp/contentImg3.png": 1329,
	"./img/newJp/contentImg4.png": 1330,
	"./img/newJp/contentImg5.png": 1331,
	"./img/newJp/contentImg6.png": 1332,
	"./img/newJp/contentImg7.png": 1333,
	"./img/newJp/contentImg8.png": 1334,
	"./img/newJp/contentImg9.png": 1335,
	"./img/newJp/contentImgHover1.png": 1336,
	"./img/newJp/contentImgHover2.png": 1337,
	"./img/newJp/contentImgHover3.png": 1338,
	"./img/newJp/contentImgHover4.png": 1339,
	"./img/newJp/contentImgHover5.png": 1340,
	"./img/newJp/contentImgHover6.png": 1341,
	"./img/newJp/contentImgHover7.png": 1342,
	"./img/newJp/contentImgHover8.png": 1343,
	"./img/newJp/contentImgHover9.png": 1344,
	"./img/newJp/handicapped_person_recruitment.png": 1658,
	"./img/newJp/home_lijichadan.png": 1124,
	"./img/newJp/home_lijichadan_hover.png": 1125,
	"./img/newJp/home_mashangjijian.png": 1126,
	"./img/newJp/home_mashangjijian_hover.png": 1127,
	"./img/newJp/home_yunfeishixiaochaxun.png": 1128,
	"./img/newJp/home_yunfeishixiaochaxun_hover.png": 1129,
	"./img/newJp/part_time_recruitment.png": 1659,
	"./img/newJp/social_recruitment.png": 1660,
	"./img/newJp/title1.png": 1345,
	"./img/newJp/title2.png": 1346,
	"./img/newJp/title3.png": 1347,
	"./img/newJp/titleAtive1.png": 1348,
	"./img/newJp/titleAtive2.png": 1349,
	"./img/newJp/titleAtive3.png": 1350,
	"./img/newKr/active-bg-shadow.png": 1351,
	"./img/newKr/kr-bg-top-left-new.png": 1016,
	"./img/newKr/kr-bg-top-left.png": 1661,
	"./img/newKr/kr-bg-top-right-new.png": 1017,
	"./img/newKr/kr-bg-top-right.png": 1662,
	"./img/newKr/kr-product-agency-card2-bg.png": 1352,
	"./img/newKr/kr-product-agency-card2-img1.png": 1353,
	"./img/newKr/kr-product-agency-card2-img2.png": 1354,
	"./img/newKr/kr-product-agency-card2-img3.png": 1355,
	"./img/newKr/kr-product-agency-card2-img4.png": 1356,
	"./img/newKr/kr-product-agency-card4-1.png": 1357,
	"./img/newKr/kr-product-agency-card4-2.png": 1358,
	"./img/newKr/kr-product-agency-card4-3.png": 1359,
	"./img/newKr/kr-product-agency-card4-4.png": 1360,
	"./img/newKr/kr-product-agency-card4-5.png": 1361,
	"./img/newKr/kr-product-agency-card4-icon1.png": 1362,
	"./img/newKr/kr-product-agency-card4-icon2.png": 1363,
	"./img/newKr/kr-product-card-icon.png": 1364,
	"./img/newKr/kr-product-card2-bg.png": 1365,
	"./img/newKr/kr-product-card2-bg1.png": 1663,
	"./img/newKr/kr-product-card2-bottom-bg.png": 1664,
	"./img/newKr/kr-product-card2-bottom-left.png": 1366,
	"./img/newKr/kr-product-card3-item2-step1.png": 1367,
	"./img/newKr/kr-product-card3-item2-step2.png": 1368,
	"./img/newKr/kr-product-card3-item2-step3.png": 1369,
	"./img/newKr/kr-product-card3-item2-step4.png": 1370,
	"./img/newKr/kr-product-card3-item3-step1.png": 1371,
	"./img/newKr/kr-product-card3-item3-step2.png": 1372,
	"./img/newKr/kr-product-card3-item3-step3.png": 1373,
	"./img/newKr/kr-product-card3-item3-step4.png": 1374,
	"./img/newKr/kr-product-card3-item4-step1.png": 1375,
	"./img/newKr/kr-product-card3-item4-step2.png": 1376,
	"./img/newKr/kr-product-card3-item4-step3.png": 1377,
	"./img/newKr/kr-product-card3-item4-step4.png": 1378,
	"./img/newKr/kr-product-card3-step1.png": 1379,
	"./img/newKr/kr-product-card3-step2.png": 1380,
	"./img/newKr/kr-product-card3-step3.png": 1381,
	"./img/newKr/kr-product-card3-step4.png": 1382,
	"./img/newKr/kr-product-content1-img-1.png": 1383,
	"./img/newKr/kr-product-content1-img-2.png": 1384,
	"./img/newKr/kr-product-content1-img-3.png": 1385,
	"./img/newKr/kr-product-content2-img-1.png": 1386,
	"./img/newKr/kr-product-content2-img-2.png": 1387,
	"./img/newKr/kr-product-content3-img-1.png": 1388,
	"./img/newKr/kr-product-content3-img-2.png": 1389,
	"./img/newKr/kr-product-content3-img-3.png": 1390,
	"./img/newKr/kr-product-content4-img-1.png": 1391,
	"./img/newKr/kr-product-content4-img-2.png": 1392,
	"./img/newKr/kr-product-ecmy-card2-bg.png": 1393,
	"./img/newKr/kr-product-ecmy-card2-img1.png": 1394,
	"./img/newKr/kr-product-ecmy-card2-img2.png": 1395,
	"./img/newKr/kr-product-ecmy-card2-img3.png": 1396,
	"./img/newKr/kr-product-ecmy-card2-img4.png": 1397,
	"./img/newKr/kr-product-ecomm-card3-bg.png": 1398,
	"./img/newKr/kr-product-final-card1-bg.png": 1399,
	"./img/newKr/kr-product-final-card1-icon1.png": 1400,
	"./img/newKr/kr-product-final-card1-img1.png": 1401,
	"./img/newKr/kr-product-final-card1-img2.png": 1402,
	"./img/newKr/kr-product-final-card1-img3.png": 1403,
	"./img/newKr/kr-product-final-card1-img4.png": 1404,
	"./img/newKr/kr-product-final-card2-img1.png": 1405,
	"./img/newKr/kr-product-final-card2-img2.png": 1406,
	"./img/newKr/kr-product-final-card2-img3.png": 1407,
	"./img/newKr/kr-product-final-card2-img4.png": 1408,
	"./img/newKr/kr-product-final-card3-left-img.png": 1409,
	"./img/newKr/kr-product-final-card3-leftTop-img.png": 1410,
	"./img/newKr/kr-product-final-card3-rightBottom-img.png": 1411,
	"./img/newKr/kr-product-final-card3-ul-icon.png": 1412,
	"./img/newKr/kr-product-finance-card2-bg.png": 1413,
	"./img/newKr/kr-product-intl-card2-bg.png": 1414,
	"./img/newKr/kr-product-intl-card2-img1.png": 1415,
	"./img/newKr/kr-product-intl-card2-img2.png": 1416,
	"./img/newKr/kr-product-intl-card2-img3.png": 1417,
	"./img/newKr/kr-product-intl-card4-img1.png": 1418,
	"./img/newKr/kr-product-intl-card4-img2.png": 1419,
	"./img/newKr/kr-product-intl-card4-img3.png": 1420,
	"./img/newKr/kr-product-supply-chain-card-bg.png": 1421,
	"./img/newKr/kr-product-supply-chain-card2-icon.png": 1422,
	"./img/newKr/xiexian.png": 1665,
	"./img/newKr/zhixian.png": 1666,
	"./img/no-data.png": 1018,
	"./img/no-data.svg": 1667,
	"./img/no-img.png": 1668,
	"./img/no-img.svg": 904,
	"./img/no_waybill_info.jpg": 962,
	"./img/notify.png": 1669,
	"./img/product-bigData-one.png": 1423,
	"./img/product-bigData-three.png": 1424,
	"./img/product-bigData-two.png": 1425,
	"./img/product-discount-one.png": 1426,
	"./img/product-discount-three.png": 1427,
	"./img/product-discount-two.png": 1428,
	"./img/product-express-one.png": 1429,
	"./img/product-express-three.png": 1430,
	"./img/product-express.two.png": 1431,
	"./img/product-package-one.png": 1130,
	"./img/product-package-three.png": 1131,
	"./img/product-package-two.png": 1132,
	"./img/product-plsc-one.png": 1432,
	"./img/product-plsc-three.png": 1433,
	"./img/product-plsc-two.png": 1434,
	"./img/product_error.png": 963,
	"./img/product_slider_title.png": 1133,
	"./img/red_strip_one.png": 897,
	"./img/red_strip_two.png": 898,
	"./img/right_more_white.png": 1435,
	"./img/selectImg.svg": 1436,
	"./img/selected.png": 979,
	"./img/service-support/aea-vertical-line.png": 1134,
	"./img/service-support/area-dest.png": 980,
	"./img/service-support/area-line.png": 1068,
	"./img/service-support/area-origin.png": 981,
	"./img/service-support/arrow.png": 1069,
	"./img/service-support/banner_m.png": 1437,
	"./img/service-support/checked.png": 1135,
	"./img/service-support/company.svg": 1670,
	"./img/service-support/empty-pc.png": 964,
	"./img/service-support/example_kyc.png": 1671,
	"./img/service-support/horn.svg": 1136,
	"./img/service-support/id_back.png": 1672,
	"./img/service-support/id_front.png": 1673,
	"./img/service-support/id_other.png": 1674,
	"./img/service-support/kyc.png": 1675,
	"./img/service-support/lang-collapse-m.png": 1438,
	"./img/service-support/lang-collapse.png": 1439,
	"./img/service-support/lang-open-m.png": 1440,
	"./img/service-support/lang-open.png": 1441,
	"./img/service-support/no_order_app.png": 965,
	"./img/service-support/no_order_pc.png": 966,
	"./img/service-support/pdf.png": 1070,
	"./img/service-support/person.svg": 1676,
	"./img/service-support/sf-icon.png": 290,
	"./img/service-support/sf-logo.png": 1137,
	"./img/service-support/shipping_type_1.png": 1071,
	"./img/service-support/shipping_type_2.png": 1138,
	"./img/service-support/shipping_type_3.png": 1072,
	"./img/service-support/shipping_type_4.png": 1442,
	"./img/service-support/shipping_type_5.png": 1443,
	"./img/service-support/tech-left.png": 900,
	"./img/service-support/tech-top.png": 895,
	"./img/sf-footer-icon.png": 1139,
	"./img/signPackingList/backgroundIcon.svg": 1444,
	"./img/signPackingList/download.svg": 1445,
	"./img/signPackingList/fail.svg": 1446,
	"./img/signPackingList/reload.svg": 1447,
	"./img/signPackingList/success.png": 1448,
	"./img/signPackingList/update.png": 1449,
	"./img/smile-arc.svg": 1450,
	"./img/success.png": 902,
	"./img/supplier/supplier-form-bg.png": 1140,
	"./img/supplier/supplier-pc.png": 1141,
	"./img/support-top-jp.png": 899,
	"./img/swap.png": 1073,
	"./img/swap_active.png": 1074,
	"./img/title-earth.png": 1075,
	"./img/title-icon.png": 1019,
	"./img/topic_bg_image.png": 1677,
	"./img/upload-active.png": 1451,
	"./img/upload-cloud.png": 1678,
	"./img/verification-successful.png": 1076,
	"./img/whats-app.png": 1452,
	"./img/white-logo-cn-express.png": 1679,
	"./img/white-logo-en-express.png": 1680,
	"./svg/about/supplier/cancel.svg": 461,
	"./svg/about/supplier/default-file.svg": 484,
	"./svg/about/supplier/pdf.svg": 485,
	"./svg/about/supplier/ppt.svg": 486,
	"./svg/about/supplier/success.svg": 458,
	"./svg/about/supplier/txt.svg": 487,
	"./svg/about/supplier/upload-cloud.svg": 462,
	"./svg/about/supplier/warning.svg": 459,
	"./svg/about/supplier/word.svg": 488,
	"./svg/about/time-left.svg": 546,
	"./svg/add.svg": 547,
	"./svg/address.svg": 548,
	"./svg/all-function.svg": 549,
	"./svg/apply_no.svg": 550,
	"./svg/apply_phone.svg": 551,
	"./svg/apply_user.svg": 552,
	"./svg/arrow-down.svg": 553,
	"./svg/billing-invoicing.svg": 554,
	"./svg/btn-download.svg": 555,
	"./svg/buttonDownload.svg": 556,
	"./svg/check-mark.svg": 557,
	"./svg/check.svg": 558,
	"./svg/checked-active.svg": 559,
	"./svg/checked.svg": 560,
	"./svg/chevron-left.svg": 561,
	"./svg/chevron-right.svg": 562,
	"./svg/chevron-route.svg": 563,
	"./svg/chevronDown.svg": 564,
	"./svg/chevronUp.svg": 565,
	"./svg/circle.svg": 566,
	"./svg/clear.svg": 567,
	"./svg/close-fat.svg": 568,
	"./svg/close-pic.svg": 569,
	"./svg/close-pic1.svg": 570,
	"./svg/close.svg": 571,
	"./svg/cn_logo.svg": 572,
	"./svg/contact-chat.svg": 573,
	"./svg/contact-email.svg": 574,
	"./svg/contact-phone.svg": 575,
	"./svg/contact-sale.svg": 576,
	"./svg/contact-service.svg": 577,
	"./svg/contact-whatapp.svg": 578,
	"./svg/contact/computer.svg": 579,
	"./svg/contact/email.svg": 580,
	"./svg/contact/phone.svg": 581,
	"./svg/contact/qq.svg": 582,
	"./svg/contact/tel.svg": 583,
	"./svg/contact_mobile_no.svg": 584,
	"./svg/contact_mobile_noJp.svg": 585,
	"./svg/contact_mobile_whatsApp.svg": 586,
	"./svg/country/au.svg": 587,
	"./svg/country/cn.svg": 588,
	"./svg/country/de.svg": 589,
	"./svg/country/eu.svg": 590,
	"./svg/country/ex.svg": 591,
	"./svg/country/fr.svg": 592,
	"./svg/country/gb.svg": 593,
	"./svg/country/hk.svg": 594,
	"./svg/country/jp.svg": 595,
	"./svg/country/kr.svg": 596,
	"./svg/country/my.svg": 597,
	"./svg/country/ru.svg": 598,
	"./svg/country/sg.svg": 599,
	"./svg/country/th.svg": 600,
	"./svg/country/us.svg": 601,
	"./svg/country/vn.svg": 602,
	"./svg/customs-inquriy.svg": 603,
	"./svg/delete.svg": 604,
	"./svg/document.svg": 605,
	"./svg/e-mail.svg": 606,
	"./svg/edit.svg": 607,
	"./svg/enterprise_login.svg": 453,
	"./svg/eye-close.svg": 608,
	"./svg/eye-open.svg": 609,
	"./svg/faqA.svg": 610,
	"./svg/faqQ.svg": 611,
	"./svg/file-delete.svg": 612,
	"./svg/fileType/excel-icon.svg": 613,
	"./svg/fileType/pdf-icon.svg": 614,
	"./svg/fileType/ppt-icon.svg": 615,
	"./svg/fileType/txt-icon.svg": 616,
	"./svg/fileType/word-icon.svg": 617,
	"./svg/form/formCopy.svg": 618,
	"./svg/form/formDelete.svg": 619,
	"./svg/form/formEdit.svg": 620,
	"./svg/header-country.svg": 621,
	"./svg/header-lang.svg": 622,
	"./svg/header-user.svg": 623,
	"./svg/homeBackground1.svg": 463,
	"./svg/homeBackground2.svg": 464,
	"./svg/home_chaxun.svg": 624,
	"./svg/home_chevron.svg": 625,
	"./svg/home_clearanceService.svg": 626,
	"./svg/home_del.svg": 627,
	"./svg/home_lijichadan.svg": 628,
	"./svg/home_mashangjijian.svg": 629,
	"./svg/home_meun.svg": 630,
	"./svg/home_yunfeishixiaochaxun.svg": 631,
	"./svg/homemore.svg": 632,
	"./svg/iconDown.svg": 633,
	"./svg/iconFrom.svg": 634,
	"./svg/iconMail.svg": 635,
	"./svg/iconNoData.svg": 636,
	"./svg/iconNotSupport.svg": 637,
	"./svg/iconPartialSupport.svg": 638,
	"./svg/iconPath.svg": 639,
	"./svg/iconReceive.svg": 640,
	"./svg/iconRight.svg": 641,
	"./svg/iconSearch.svg": 642,
	"./svg/iconSupport.svg": 643,
	"./svg/icons/shipping-method.svg": 644,
	"./svg/info.svg": 645,
	"./svg/info_solid.svg": 646,
	"./svg/lijichaxun.svg": 647,
	"./svg/logo_black.svg": 648,
	"./svg/logo_white.svg": 649,
	"./svg/mail.svg": 650,
	"./svg/mark_exclamation.svg": 651,
	"./svg/mark_question.svg": 652,
	"./svg/mark_question_solid.svg": 653,
	"./svg/message/message_error.svg": 654,
	"./svg/message/message_info.svg": 655,
	"./svg/message/message_success.svg": 656,
	"./svg/message/message_warning.svg": 657,
	"./svg/message/message_warning_active.svg": 658,
	"./svg/mobile-close.svg": 659,
	"./svg/more.svg": 660,
	"./svg/notify.svg": 661,
	"./svg/notify1.svg": 662,
	"./svg/notify2.svg": 663,
	"./svg/package-box.svg": 664,
	"./svg/pdf.svg": 665,
	"./svg/personalCanada.svg": 454,
	"./svg/personalUs.svg": 455,
	"./svg/plus.svg": 666,
	"./svg/queryWaybill.svg": 667,
	"./svg/question.svg": 456,
	"./svg/right-nav-back-top.svg": 668,
	"./svg/search-left.svg": 669,
	"./svg/search.svg": 670,
	"./svg/sendMail.svg": 671,
	"./svg/senderPerson.svg": 489,
	"./svg/shipment-complaints.svg": 672,
	"./svg/solidArrow.svg": 673,
	"./svg/submitHistoryIcon.svg": 674,
	"./svg/support/apply-type.svg": 675,
	"./svg/support/direction.svg": 676,
	"./svg/support/doc-upload-type.svg": 677,
	"./svg/support/freightArrow.svg": 678,
	"./svg/support/freightDelivery.svg": 679,
	"./svg/support/freightEdit.svg": 680,
	"./svg/support/support_curve.svg": 681,
	"./svg/support/support_exchange.svg": 682,
	"./svg/support/support_title_bg.svg": 683,
	"./svg/symbol-add.svg": 684,
	"./svg/take-picture.svg": 685,
	"./svg/trash-2.svg": 686,
	"./svg/upload.svg": 687,
	"./svg/waybill/collect.svg": 688,
	"./svg/waybill/delivered.svg": 689,
	"./svg/waybill/delivery.svg": 690,
	"./svg/waybill/express-direction.svg": 691,
	"./svg/waybill/invalid.svg": 692,
	"./svg/waybill/landing.svg": 693,
	"./svg/waybill/other.svg": 694,
	"./svg/waybill/packaged.svg": 695,
	"./svg/waybill/pickedup.svg": 696,
	"./svg/waybill/picking.svg": 697,
	"./svg/waybill/received.svg": 698,
	"./svg/waybill/signed.svg": 699,
	"./svg/waybill/take_off.svg": 700,
	"./svg/wechat.svg": 701,
	"./svg/whole-calculate.svg": 702,
	"./svg/whole-shipping.svg": 703,
	"./svg/whole-tracking.svg": 704,
	"./video/banner.mp4": 1077,
	"./webp/img/SF EXPRESS.webp": 1681,
	"./webp/img/about/about_us_bg.webp": 1682,
	"./webp/img/about/company_address.webp": 1683,
	"./webp/img/about/company_introduction.webp": 1684,
	"./webp/img/about/contact_bg.webp": 1685,
	"./webp/img/about/contact_bg_m.webp": 1686,
	"./webp/img/about/intro/about_001.webp": 1687,
	"./webp/img/about/intro/about_002.webp": 1688,
	"./webp/img/about/intro/about_003.webp": 1689,
	"./webp/img/about/intro/about_004.webp": 1690,
	"./webp/img/about/intro/banner.webp": 1691,
	"./webp/img/about/intro/banner_bg_001.webp": 1692,
	"./webp/img/about/intro/banner_bg_002.webp": 1693,
	"./webp/img/about/intro/course/course_001.webp": 1694,
	"./webp/img/about/intro/course/course_0010.webp": 1695,
	"./webp/img/about/intro/course/course_0011.webp": 1696,
	"./webp/img/about/intro/course/course_0012.webp": 1697,
	"./webp/img/about/intro/course/course_0013.webp": 1698,
	"./webp/img/about/intro/course/course_0014.webp": 1699,
	"./webp/img/about/intro/course/course_002.webp": 1700,
	"./webp/img/about/intro/course/course_003.webp": 1701,
	"./webp/img/about/intro/course/course_004.webp": 1702,
	"./webp/img/about/intro/course/course_005.webp": 1703,
	"./webp/img/about/intro/course/course_006.webp": 1704,
	"./webp/img/about/intro/course/course_007.webp": 1705,
	"./webp/img/about/intro/course/course_008.webp": 1706,
	"./webp/img/about/intro/course/course_009.webp": 1707,
	"./webp/img/about/intro/course/course_line.webp": 1708,
	"./webp/img/about/intro/culture/en_US.webp": 1709,
	"./webp/img/about/intro/culture/th_TH.webp": 1710,
	"./webp/img/about/intro/culture/vi_VN.webp": 1711,
	"./webp/img/about/intro/culture/zh_CN.webp": 1712,
	"./webp/img/about/intro/culture2/en_US.webp": 1713,
	"./webp/img/about/intro/culture2/ko_KR.webp": 1714,
	"./webp/img/about/intro/culture2/th_TH.webp": 1715,
	"./webp/img/about/intro/culture2/vi_VN.webp": 1716,
	"./webp/img/about/intro/culture2/zh_CN.webp": 1717,
	"./webp/img/about/intro/desire/desire_001.webp": 1718,
	"./webp/img/about/intro/desire/desire_002.webp": 1719,
	"./webp/img/about/intro/desire/desire_003.webp": 1720,
	"./webp/img/about/intro/desire/desire_004.webp": 1721,
	"./webp/img/about/intro/desire/desire_005.webp": 1722,
	"./webp/img/about/intro/honor/honor_001.webp": 1723,
	"./webp/img/about/intro/honor/honor_002.webp": 1724,
	"./webp/img/about/intro/honor/honor_003.webp": 1725,
	"./webp/img/about/intro/honor/honor_004.webp": 1726,
	"./webp/img/about/intro/honor/honor_005.webp": 1727,
	"./webp/img/about/intro/honor/honor_sg_001.webp": 1728,
	"./webp/img/about/intro/honor/honor_sg_002.webp": 1729,
	"./webp/img/about/intro/icon_001.webp": 1730,
	"./webp/img/about/intro/icon_002.webp": 1731,
	"./webp/img/about/intro/icon_003.webp": 1732,
	"./webp/img/about/intro/icon_004.webp": 1733,
	"./webp/img/about/intro/icon_005.webp": 1734,
	"./webp/img/about/intro/icon_006.webp": 1735,
	"./webp/img/about/intro/koreasf/cargo.webp": 1453,
	"./webp/img/about/intro/koreasf/charter-1.webp": 1736,
	"./webp/img/about/intro/koreasf/charter-2.webp": 1737,
	"./webp/img/about/intro/koreasf/charter-3.webp": 1738,
	"./webp/img/about/intro/koreasf/coverage.webp": 1454,
	"./webp/img/about/intro/koreasf/earth-card.webp": 1455,
	"./webp/img/about/intro/koreasf/ezhou-airport.webp": 1739,
	"./webp/img/about/intro/koreasf/fleet-plane.webp": 1456,
	"./webp/img/about/intro/koreasf/korea-map-watermark.webp": 1457,
	"./webp/img/about/intro/koreasf/news-1.webp": 1458,
	"./webp/img/about/intro/koreasf/news-2.webp": 1459,
	"./webp/img/about/intro/koreasf/news-3.webp": 1460,
	"./webp/img/about/intro/koreasf/revenue.webp": 1461,
	"./webp/img/about/intro/koreasf/service-express-figure.webp": 1740,
	"./webp/img/about/intro/koreasf/service-express.webp": 1741,
	"./webp/img/about/intro/koreasf/service-finance.webp": 1742,
	"./webp/img/about/intro/koreasf/service-kandash.webp": 1743,
	"./webp/img/about/intro/koreasf/service-points.webp": 1462,
	"./webp/img/about/intro/koreasf/service-smart.webp": 1744,
	"./webp/img/about/intro/koreasf/service-supply.webp": 1745,
	"./webp/img/about/intro/koreasf/sf-korea-logo.webp": 1142,
	"./webp/img/about/intro/koreasf/sf-korea-photo.webp": 1463,
	"./webp/img/about/intro/koreasf/staff-photo-2.webp": 1464,
	"./webp/img/about/intro/koreasf/staff-photo-3.webp": 1465,
	"./webp/img/about/intro/koreasf/staff-photo-main.webp": 1466,
	"./webp/img/about/intro/koreasf/xiejiantou.webp": 1746,
	"./webp/img/about/intro/koreasf/zhixianjiantou-red.png": 1747,
	"./webp/img/about/intro/koreasf/zhixianjiantou.webp": 1748,
	"./webp/img/about/intro/mb/banner.webp": 1749,
	"./webp/img/about/intro/mb/product_bg.webp": 1750,
	"./webp/img/about/jp-about-us-bg.webp": 1751,
	"./webp/img/about/location.webp": 1752,
	"./webp/img/about/pc_board.webp": 1753,
	"./webp/img/about/pc_careers.webp": 1754,
	"./webp/img/about/pc_contact.webp": 1755,
	"./webp/img/about/pc_intr.webp": 1756,
	"./webp/img/about/pc_text_bg.webp": 1757,
	"./webp/img/about/president_message.webp": 1758,
	"./webp/img/about/president_message_en.webp": 1759,
	"./webp/img/about/president_message_ja.webp": 1760,
	"./webp/img/about/president_message_sc.webp": 1761,
	"./webp/img/about/service_point.webp": 1762,
	"./webp/img/about/talent_recruitment.webp": 1763,
	"./webp/img/alert-circle-solid.webp": 1764,
	"./webp/img/allCustomsClearanceServices/allCustomsClearanceServicesMainTop.webp": 1765,
	"./webp/img/allCustomsClearanceServices/pieceOneImg1.webp": 1766,
	"./webp/img/allCustomsClearanceServices/pieceOneImg2.webp": 1767,
	"./webp/img/allCustomsClearanceServices/pieceOneImg3.webp": 1768,
	"./webp/img/allCustomsClearanceServices/pieceOneImg4.webp": 1769,
	"./webp/img/allCustomsClearanceServices/pieceOneImg5.webp": 1770,
	"./webp/img/allCustomsClearanceServices/pieceOneImg6.webp": 1771,
	"./webp/img/allCustomsClearanceServices/rightBottom1.svg": 1772,
	"./webp/img/allCustomsClearanceServices/rightBottom2.svg": 1773,
	"./webp/img/allCustomsClearanceServices/rightBottom3.svg": 1774,
	"./webp/img/allCustomsClearanceServices/rightBottom4.svg": 1775,
	"./webp/img/allCustomsClearanceServices/rightBottom5.svg": 1776,
	"./webp/img/allCustomsClearanceServices/rightBottom6.svg": 1777,
	"./webp/img/allCustomsClearanceServices/rightBottom7.svg": 1778,
	"./webp/img/allCustomsClearanceServices/selfServiceImg1.svg": 1779,
	"./webp/img/allCustomsClearanceServices/selfServiceImg2.svg": 1780,
	"./webp/img/allCustomsClearanceServices/selfServiceImg3.svg": 1781,
	"./webp/img/arrow_right.webp": 1782,
	"./webp/img/arrow_right_more.webp": 1783,
	"./webp/img/arrow_right_two.webp": 1784,
	"./webp/img/arrows/arrow-right-gray.webp": 1785,
	"./webp/img/arrows/arrow-right-white.webp": 1786,
	"./webp/img/arrows/arrow.webp": 1787,
	"./webp/img/arrows/up.webp": 1788,
	"./webp/img/businessCooperation/businessCooperation-pc.webp": 1789,
	"./webp/img/chevron-up.webp": 1790,
	"./webp/img/class-banner.webp": 1791,
	"./webp/img/class-banner1.webp": 1792,
	"./webp/img/class-banner_bg.webp": 1793,
	"./webp/img/concat_computer.webp": 1794,
	"./webp/img/concat_email.webp": 1795,
	"./webp/img/concat_phone.webp": 1796,
	"./webp/img/concat_qq.webp": 1797,
	"./webp/img/consign/guide_m_vi.webp": 1798,
	"./webp/img/consign/guide_vi.webp": 1799,
	"./webp/img/consign/img_1.webp": 1800,
	"./webp/img/consign/qrcode_2.webp": 1801,
	"./webp/img/consign/qrcode_3.webp": 1802,
	"./webp/img/consign/sf_go_vn.webp": 1803,
	"./webp/img/consign/wrapper_bg.webp": 1804,
	"./webp/img/consign/wrapper_m_bg.webp": 1805,
	"./webp/img/contact-portrait.webp": 1806,
	"./webp/img/customerService.webp": 1807,
	"./webp/img/dashed.webp": 1808,
	"./webp/img/edit.webp": 1809,
	"./webp/img/error_404bg-m.webp": 1810,
	"./webp/img/error_404bg.webp": 1811,
	"./webp/img/europe.svg": 1812,
	"./webp/img/footer/gb_xhs_2wm.svg": 1813,
	"./webp/img/footer/ic_close.svg": 1814,
	"./webp/img/footer/ic_qrcode_douyin.webp": 1815,
	"./webp/img/footer/ic_qrcode_facebook.webp": 1816,
	"./webp/img/footer/ic_qrcode_ins.webp": 1817,
	"./webp/img/footer/ic_qrcode_line.webp": 1818,
	"./webp/img/footer/ic_qrcode_lingying.webp": 1819,
	"./webp/img/footer/ic_qrcode_linkin.webp": 1820,
	"./webp/img/footer/ic_qrcode_tiktok.webp": 1821,
	"./webp/img/footer/ic_qrcode_tw.webp": 1822,
	"./webp/img/footer/ic_qrcode_wechat.webp": 1823,
	"./webp/img/footer/ic_qrcode_weibo.webp": 1824,
	"./webp/img/footer/ic_qrcode_youbute.webp": 1825,
	"./webp/img/footer/jialiwuliu.webp": 1826,
	"./webp/img/footer/jp_xhs_2wm.webp": 1827,
	"./webp/img/footer/jp_xhs_qrcode.webp": 1828,
	"./webp/img/footer/line.svg": 1829,
	"./webp/img/footer/my_qrcode_facebook.webp": 1830,
	"./webp/img/footer/my_qrcode_ins.webp": 1831,
	"./webp/img/footer/my_qrcode_ins_us.webp": 1832,
	"./webp/img/footer/my_qrcode_lingying.webp": 1833,
	"./webp/img/footer/my_qrcode_lingying_us.webp": 1834,
	"./webp/img/footer/ph_qrcode_viber.webp": 1835,
	"./webp/img/footer/ph_qrcode_wechat.webp": 1836,
	"./webp/img/footer/ph_qrcode_whatsapp.webp": 1837,
	"./webp/img/footer/ph_qrcode_xiaohongshu.webp": 1838,
	"./webp/img/footer/sg_qrcode_whatsapp.webp": 1839,
	"./webp/img/footer/us_xhs.webp": 1840,
	"./webp/img/footer/vn_qrcode_fb.webp": 1841,
	"./webp/img/footer/vn_qrcode_tk.webp": 1842,
	"./webp/img/footer/vn_qrcode_wechat.webp": 1843,
	"./webp/img/footer/vn_qrcode_zalo.webp": 1844,
	"./webp/img/format/doc.webp": 1845,
	"./webp/img/format/jpg.webp": 1846,
	"./webp/img/format/pdf.webp": 1847,
	"./webp/img/format/png.webp": 1848,
	"./webp/img/format/xls.webp": 1849,
	"./webp/img/header-countryicon.webp": 1850,
	"./webp/img/header-phoneicon.webp": 1851,
	"./webp/img/home/dianshang.webp": 1852,
	"./webp/img/home/extension_news_bg.webp": 1853,
	"./webp/img/home/homeRightImg.webp": 1854,
	"./webp/img/home/kuaidi.webp": 1855,
	"./webp/img/home/newSolution_bg1.webp": 1856,
	"./webp/img/home/product_01.webp": 1857,
	"./webp/img/home/product_02.webp": 1858,
	"./webp/img/home/product_bg_01.webp": 1859,
	"./webp/img/home/product_bg_01_en_01.webp": 1860,
	"./webp/img/home/product_bg_01_sc_01.webp": 1861,
	"./webp/img/home/product_bg_02.webp": 1862,
	"./webp/img/home/product_bg_new_01.svg": 1863,
	"./webp/img/home/product_bg_new_02.svg": 1864,
	"./webp/img/home/product_bg_new_03.webp": 1865,
	"./webp/img/home/product_bg_new_04.webp": 1866,
	"./webp/img/home/product_mb_01.webp": 1867,
	"./webp/img/home/product_mb_02.webp": 1868,
	"./webp/img/home/product_mb_cn_kr.svg": 1869,
	"./webp/img/home/product_mb_cn_kr.webp": 1870,
	"./webp/img/home/product_mb_new_01.svg": 1871,
	"./webp/img/home/product_mb_new_02.svg": 1872,
	"./webp/img/home/product_mb_new_03.webp": 1873,
	"./webp/img/home/product_mb_new_04.webp": 1874,
	"./webp/img/home/product_mb_us_eu_au_fr_de.svg": 1875,
	"./webp/img/home/product_mb_us_eu_au_fr_de.webp": 1876,
	"./webp/img/home/product_mb_vn_th_my_sg_ph.svg": 1877,
	"./webp/img/home/product_mb_vn_th_my_sg_ph.webp": 1878,
	"./webp/img/home/service_notice.webp": 1879,
	"./webp/img/home/solution_bg1.webp": 1880,
	"./webp/img/home/solution_bg2.webp": 1881,
	"./webp/img/home_search_02.webp": 1882,
	"./webp/img/icons/JapanIcon.webp": 1883,
	"./webp/img/icons/active_point.svg": 1884,
	"./webp/img/icons/address.svg": 1885,
	"./webp/img/icons/appTableNoData.webp": 1886,
	"./webp/img/icons/arrow/double-arrows.svg": 1887,
	"./webp/img/icons/arrow_bg.svg": 1888,
	"./webp/img/icons/arrow_down.svg": 1889,
	"./webp/img/icons/back2Top.webp": 1890,
	"./webp/img/icons/chadan.svg": 1891,
	"./webp/img/icons/check.webp": 1892,
	"./webp/img/icons/close.webp": 1893,
	"./webp/img/icons/complete.webp": 1894,
	"./webp/img/icons/curve-black.svg": 1895,
	"./webp/img/icons/curve-grey.svg": 1896,
	"./webp/img/icons/curve/curve-active.svg": 1897,
	"./webp/img/icons/curve/curve-inactive.svg": 1898,
	"./webp/img/icons/customsDeclaration.svg": 1899,
	"./webp/img/icons/customsDeclarationActive.svg": 1900,
	"./webp/img/icons/douyin.svg": 1901,
	"./webp/img/icons/drop_point.svg": 1902,
	"./webp/img/icons/empty-result.svg": 1903,
	"./webp/img/icons/error.svg": 1904,
	"./webp/img/icons/facebook.svg": 1905,
	"./webp/img/icons/gb_xhs.svg": 1906,
	"./webp/img/icons/incomplete.webp": 1907,
	"./webp/img/icons/ins.svg": 1908,
	"./webp/img/icons/jijian.svg": 1909,
	"./webp/img/icons/jp_xhs.svg": 1910,
	"./webp/img/icons/jp_xhs.webp": 1911,
	"./webp/img/icons/kakao.svg": 1912,
	"./webp/img/icons/kefu.svg": 1913,
	"./webp/img/icons/kr-blog.svg": 1914,
	"./webp/img/icons/kuaisuxunjia.svg": 1915,
	"./webp/img/icons/landing/enterprice.svg": 1916,
	"./webp/img/icons/landing/rectangle.svg": 1917,
	"./webp/img/icons/line.webp": 1918,
	"./webp/img/icons/lingyin.svg": 1919,
	"./webp/img/icons/local_point.webp": 1920,
	"./webp/img/icons/logo.svg": 1921,
	"./webp/img/icons/mashangjijian.svg": 1922,
	"./webp/img/icons/overturn.svg": 1923,
	"./webp/img/icons/person.svg": 1924,
	"./webp/img/icons/pick_point.svg": 1925,
	"./webp/img/icons/qq_detail.svg": 1926,
	"./webp/img/icons/quarter-checked.webp": 1927,
	"./webp/img/icons/search_point.svg": 1928,
	"./webp/img/icons/shangwuhezuo.svg": 1929,
	"./webp/img/icons/sousuo.svg": 1930,
	"./webp/img/icons/submitHistoryIcon.svg": 1931,
	"./webp/img/icons/submitHistoryIconActive.svg": 1932,
	"./webp/img/icons/success-icon.svg": 1933,
	"./webp/img/icons/success.svg": 1934,
	"./webp/img/icons/support/allow.svg": 1935,
	"./webp/img/icons/support/arrow-to.svg": 1936,
	"./webp/img/icons/support/iconPath.svg": 1937,
	"./webp/img/icons/support/picture.svg": 1938,
	"./webp/img/icons/support/prohibit.svg": 1939,
	"./webp/img/icons/support/restrict.svg": 1940,
	"./webp/img/icons/support/shipping-flow.svg": 1941,
	"./webp/img/icons/switch.svg": 1942,
	"./webp/img/icons/time.svg": 1943,
	"./webp/img/icons/tongzhi1.svg": 1944,
	"./webp/img/icons/tongzhi2.svg": 1945,
	"./webp/img/icons/totalValue5.svg": 1946,
	"./webp/img/icons/tw.svg": 1947,
	"./webp/img/icons/tw.webp": 1948,
	"./webp/img/icons/viber.webp": 1949,
	"./webp/img/icons/vn_qrcode_wechat.webp": 1950,
	"./webp/img/icons/warning-icon.svg": 1951,
	"./webp/img/icons/warning.svg": 1952,
	"./webp/img/icons/wb_detail.svg": 1953,
	"./webp/img/icons/weibo.svg": 1954,
	"./webp/img/icons/whatsapp.webp": 1955,
	"./webp/img/icons/wx.svg": 1956,
	"./webp/img/icons/wx_detail.svg": 1957,
	"./webp/img/icons/xiaohongshu.webp": 1958,
	"./webp/img/icons/youbube.svg": 1959,
	"./webp/img/icons/zalo.svg": 1960,
	"./webp/img/img-error.webp": 1961,
	"./webp/img/intl-app-logo.webp": 1962,
	"./webp/img/invoice/invoice-template-au.webp": 1963,
	"./webp/img/invoice/invoice-template-nz.webp": 1964,
	"./webp/img/landing/active_product1.webp": 1965,
	"./webp/img/landing/active_product2.webp": 1966,
	"./webp/img/landing/active_product3.webp": 1967,
	"./webp/img/landing/active_product4.webp": 1968,
	"./webp/img/landing/apps/express-consign-miniapp.webp": 1969,
	"./webp/img/landing/apps/express-consign-sfapp.webp": 1970,
	"./webp/img/landing/apps/home-miniapp.webp": 1971,
	"./webp/img/landing/apps/main-consign-miniapp.webp": 1972,
	"./webp/img/landing/apps/main-consign-sfapp.webp": 1973,
	"./webp/img/landing/banner_ad.webp": 1974,
	"./webp/img/landing/bend_arrow.webp": 1975,
	"./webp/img/landing/contact_us.webp": 1976,
	"./webp/img/landing/earth.webp": 1977,
	"./webp/img/landing/earth1.webp": 1978,
	"./webp/img/landing/footer_bg.webp": 1979,
	"./webp/img/landing/icons/amazon.svg": 1980,
	"./webp/img/landing/icons/authentication.svg": 1981,
	"./webp/img/landing/icons/cainiao.svg": 1982,
	"./webp/img/landing/icons/car.svg": 1983,
	"./webp/img/landing/icons/compensation.svg": 1984,
	"./webp/img/landing/icons/icon_1.webp": 1985,
	"./webp/img/landing/icons/icon_2.webp": 1986,
	"./webp/img/landing/icons/icon_3.webp": 1987,
	"./webp/img/landing/icons/icon_4.webp": 1988,
	"./webp/img/landing/icons/icon_5.svg": 1989,
	"./webp/img/landing/icons/icon_6.svg": 1990,
	"./webp/img/landing/icons/internet.svg": 1991,
	"./webp/img/landing/icons/joom.svg": 1992,
	"./webp/img/landing/icons/lazada.svg": 1993,
	"./webp/img/landing/icons/pinduoduo.svg": 1994,
	"./webp/img/landing/icons/service.svg": 1995,
	"./webp/img/landing/icons/service_1.webp": 1996,
	"./webp/img/landing/icons/service_2.webp": 1997,
	"./webp/img/landing/icons/service_3.webp": 1998,
	"./webp/img/landing/icons/service_4.webp": 1999,
	"./webp/img/landing/icons/shopify.svg": 2000,
	"./webp/img/landing/icons/track.svg": 2001,
	"./webp/img/landing/icons/wish.svg": 2002,
	"./webp/img/landing/line.webp": 2003,
	"./webp/img/landing/people.webp": 2004,
	"./webp/img/landing/platform.webp": 2005,
	"./webp/img/landing/product1.webp": 2006,
	"./webp/img/landing/product2.webp": 2007,
	"./webp/img/landing/product3.webp": 2008,
	"./webp/img/landing/product4.webp": 2009,
	"./webp/img/landing/route_country.webp": 2010,
	"./webp/img/landing/service_bg.webp": 2011,
	"./webp/img/loading.gif": 2012,
	"./webp/img/loading.webp": 2013,
	"./webp/img/loading/snow.webp": 2014,
	"./webp/img/logistics/banner.webp": 2015,
	"./webp/img/logistics/bg_circle.webp": 2016,
	"./webp/img/logistics/cross-e-commerce.webp": 2017,
	"./webp/img/logistics/delivery.webp": 2018,
	"./webp/img/logistics/discts.webp": 2019,
	"./webp/img/logistics/fast.webp": 2020,
	"./webp/img/logistics/ic_reddot.webp": 2021,
	"./webp/img/logistics/icon1.webp": 2022,
	"./webp/img/logistics/icon2.webp": 2023,
	"./webp/img/logistics/icon3.webp": 2024,
	"./webp/img/logistics/icon4.webp": 2025,
	"./webp/img/logistics/icon5.webp": 2026,
	"./webp/img/logistics/icon6.webp": 2027,
	"./webp/img/logistics/icon7.webp": 2028,
	"./webp/img/logistics/icon8.webp": 2029,
	"./webp/img/logistics/parcel.webp": 2030,
	"./webp/img/logistics/pic1.webp": 2031,
	"./webp/img/logistics/pic12.webp": 2032,
	"./webp/img/logistics/pic3.webp": 2033,
	"./webp/img/logistics/pic4_bg.webp": 2034,
	"./webp/img/logistics/pic4_bg_hover.webp": 2035,
	"./webp/img/logistics/pic5.webp": 2036,
	"./webp/img/logistics/pic5_bg.webp": 2037,
	"./webp/img/logistics/pic5_bg_hover.webp": 2038,
	"./webp/img/logistics/pic6.webp": 2039,
	"./webp/img/logistics/pic6_bg.webp": 2040,
	"./webp/img/logistics/product_ecomence_error.webp": 2041,
	"./webp/img/logistics/product_express_error.webp": 2042,
	"./webp/img/logistics/sfbuy.webp": 2043,
	"./webp/img/logistics/warehouse.webp": 2044,
	"./webp/img/logo-black-express.webp": 2045,
	"./webp/img/logo-black.webp": 2046,
	"./webp/img/logo-chinese-express.webp": 2047,
	"./webp/img/logo-intl-express.webp": 2048,
	"./webp/img/logo-intl-expresstc.webp": 2049,
	"./webp/img/logo-intl-white.webp": 2050,
	"./webp/img/logo-intl.webp": 2051,
	"./webp/img/logo.webp": 2052,
	"./webp/img/navs/businessCooperation-on.webp": 2053,
	"./webp/img/navs/businessCooperation.webp": 2054,
	"./webp/img/navs/customerService-on.webp": 2055,
	"./webp/img/navs/customerService.webp": 2056,
	"./webp/img/navs/jpBusinessCooperation.webp": 2057,
	"./webp/img/navs/jpCustomerService.webp": 2058,
	"./webp/img/navs/jpSuggestion.webp": 2059,
	"./webp/img/navs/popover-bg.webp": 2060,
	"./webp/img/navs/suggestion-on.webp": 2061,
	"./webp/img/navs/suggestion.webp": 2062,
	"./webp/img/navs/wechat-on.webp": 2063,
	"./webp/img/navs/wechat.webp": 2064,
	"./webp/img/newJp/arrow-down-s-line.webp": 2065,
	"./webp/img/newJp/arrowRight.webp": 2066,
	"./webp/img/newJp/backgroundImg.webp": 2067,
	"./webp/img/newJp/backgroundImg2.webp": 2068,
	"./webp/img/newJp/campus_recruitment.webp": 2069,
	"./webp/img/newJp/close-fat.webp": 2070,
	"./webp/img/newJp/contact_mobile_noJp.webp": 2071,
	"./webp/img/newJp/contact_mobile_whatsApp_jp.webp": 2072,
	"./webp/img/newJp/contentImg1.webp": 2073,
	"./webp/img/newJp/contentImg2.webp": 2074,
	"./webp/img/newJp/contentImg3.webp": 2075,
	"./webp/img/newJp/contentImg4.webp": 2076,
	"./webp/img/newJp/contentImg5.webp": 2077,
	"./webp/img/newJp/contentImg6.webp": 2078,
	"./webp/img/newJp/contentImg7.webp": 2079,
	"./webp/img/newJp/contentImgHover1.webp": 2080,
	"./webp/img/newJp/contentImgHover2.webp": 2081,
	"./webp/img/newJp/contentImgHover3.webp": 2082,
	"./webp/img/newJp/contentImgHover4.webp": 2083,
	"./webp/img/newJp/contentImgHover5.webp": 2084,
	"./webp/img/newJp/contentImgHover6.webp": 2085,
	"./webp/img/newJp/contentImgHover7.webp": 2086,
	"./webp/img/newJp/handicapped_person_recruitment.webp": 2087,
	"./webp/img/newJp/home_lijichadan.webp": 2088,
	"./webp/img/newJp/home_lijichadan_hover.webp": 2089,
	"./webp/img/newJp/home_mashangjijian.webp": 2090,
	"./webp/img/newJp/home_mashangjijian_hover.webp": 2091,
	"./webp/img/newJp/home_yunfeishixiaochaxun.webp": 2092,
	"./webp/img/newJp/home_yunfeishixiaochaxun_hover.webp": 2093,
	"./webp/img/newJp/part_time_recruitment.webp": 2094,
	"./webp/img/newJp/social_recruitment.webp": 2095,
	"./webp/img/newJp/title1.webp": 2096,
	"./webp/img/newJp/title2.webp": 2097,
	"./webp/img/newJp/title3.webp": 2098,
	"./webp/img/newJp/titleAtive1.webp": 2099,
	"./webp/img/newJp/titleAtive2.webp": 2100,
	"./webp/img/newJp/titleAtive3.webp": 2101,
	"./webp/img/no-data.svg": 2102,
	"./webp/img/no-data.webp": 2103,
	"./webp/img/notify.webp": 2104,
	"./webp/img/product_error.webp": 2105,
	"./webp/img/product_slider_title.webp": 2106,
	"./webp/img/red_strip_one.webp": 2107,
	"./webp/img/red_strip_two.webp": 2108,
	"./webp/img/right_more_white.webp": 2109,
	"./webp/img/selectImg.svg": 2110,
	"./webp/img/selected.webp": 2111,
	"./webp/img/service-support/aea-vertical-line.webp": 2112,
	"./webp/img/service-support/area-dest.webp": 2113,
	"./webp/img/service-support/area-line.webp": 2114,
	"./webp/img/service-support/area-origin.webp": 2115,
	"./webp/img/service-support/arrow.webp": 2116,
	"./webp/img/service-support/banner_m.webp": 2117,
	"./webp/img/service-support/checked.webp": 2118,
	"./webp/img/service-support/company.svg": 2119,
	"./webp/img/service-support/empty-pc.webp": 2120,
	"./webp/img/service-support/example_kyc.webp": 2121,
	"./webp/img/service-support/horn.svg": 2122,
	"./webp/img/service-support/id_back.webp": 2123,
	"./webp/img/service-support/id_front.webp": 2124,
	"./webp/img/service-support/id_other.webp": 2125,
	"./webp/img/service-support/kyc.webp": 2126,
	"./webp/img/service-support/lang-collapse-m.webp": 2127,
	"./webp/img/service-support/lang-collapse.webp": 2128,
	"./webp/img/service-support/lang-open-m.webp": 2129,
	"./webp/img/service-support/lang-open.webp": 2130,
	"./webp/img/service-support/no_order_app.webp": 2131,
	"./webp/img/service-support/no_order_pc.webp": 2132,
	"./webp/img/service-support/pdf.webp": 2133,
	"./webp/img/service-support/person.svg": 2134,
	"./webp/img/service-support/sf-icon.webp": 2135,
	"./webp/img/service-support/sf-logo.webp": 2136,
	"./webp/img/service-support/shipping_type_1.webp": 2137,
	"./webp/img/service-support/shipping_type_2.webp": 2138,
	"./webp/img/service-support/shipping_type_3.webp": 2139,
	"./webp/img/service-support/shipping_type_4.webp": 2140,
	"./webp/img/service-support/shipping_type_5.webp": 2141,
	"./webp/img/service-support/tech-left.webp": 2142,
	"./webp/img/service-support/tech-top.webp": 2143,
	"./webp/img/sf-footer-icon.webp": 2144,
	"./webp/img/signPackingList/backgroundIcon.svg": 2145,
	"./webp/img/signPackingList/download.svg": 2146,
	"./webp/img/signPackingList/fail.svg": 2147,
	"./webp/img/signPackingList/reload.svg": 2148,
	"./webp/img/signPackingList/success.webp": 2149,
	"./webp/img/signPackingList/update.webp": 2150,
	"./webp/img/success.webp": 2151,
	"./webp/img/supplier/supplier-form-bg.webp": 2152,
	"./webp/img/supplier/supplier-pc.webp": 2153,
	"./webp/img/swap.webp": 2154,
	"./webp/img/swap_active.webp": 2155,
	"./webp/img/title-earth.webp": 2156,
	"./webp/img/title-icon.webp": 2157,
	"./webp/img/topic_bg_image.webp": 2158,
	"./webp/img/upload-active.webp": 2159,
	"./webp/img/upload-cloud.webp": 2160,
	"./webp/img/whats-app.webp": 2161,
	"./webp/img/white-logo-cn-express.webp": 2162,
	"./webp/img/white-logo-en-express.webp": 2163
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1536;